import WholenessRingWithOverviewSkeleton from '@/components/molecules/Skeletons/WholenessRingWithOverviewSkeleton';
import WholenessRingWithOverview from '@/components/organisms/WholenessRingWithOverview';
import WholenessTrends from '@/components/molecules/WholenessTrends';
import { MAX_CONTAINER_WIDTH } from '@/constants/dimensions';
import usePeerSupportDashboard from '@/hooks/peersupport/usePeerSupportDashboard';
import CreatorPrompt from '@/modules/peer-support/CreatorPrompt';
import PeerSupportDashboardOverview from '@/modules/peer-support/PeerSupportDashboardOverview';
import TeamConcernsWidget from '@/modules/organization/TeamConcernsWidget';
import { Box, HStack, VStack } from '@chakra-ui/react';
import { createFileRoute, redirect } from '@tanstack/react-router';

const PeerSupportDashboard = () => {
  // TODO: probably unnecessary month-selection logic
  // const currentMonthIndex = new Date().getMonth();
  // const currentYear = new Date().getFullYear();
  // const [selectedMonthIndex, setSelectedMonthIndex] = useState(currentMonthIndex.toString());

  // const isSelectingMonthFromPreviousYear = currentMonthIndex < parseInt(selectedMonthIndex);
  // const selectedMonthData = `${isSelectingMonthFromPreviousYear ? currentYear - 1 : currentYear}-${parseInt(selectedMonthIndex) + 1}`;
  const { data: peerSupportDashboard, isLoading } = usePeerSupportDashboard(''); // selectedMonthData

  if (isLoading) {
    return <WholenessRingWithOverviewSkeleton title={`Brand's Wholeness Ring`} subtitle="" titleInTopRow />;
  }

  return (
    <VStack width={MAX_CONTAINER_WIDTH} gap={'120px'} marginTop={'37px'} marginBottom={'120px'}>
      <VStack width={'100%'} gap={'100px'}>
        <WholenessRingWithOverview
          titleInTopRow
          isOrganizationOverview
          isHoverable
          dashboardScores={peerSupportDashboard?.score}
          title={`${peerSupportDashboard?.name}'s Wholeness Ring`}
          isSendScreenerReminderButtonShown={true}
          wholenessObservation={peerSupportDashboard?.wholenessObservation}
          organizationName={peerSupportDashboard?.name}
        />

        <HStack width={'100%'} alignItems={'center'} gap={'75px'}>
          <Box flex={1} minWidth={0}>
            <WholenessTrends
              dashboardTrendData={peerSupportDashboard?.trends ?? null}
              progressData={peerSupportDashboard?.progress}
            />
          </Box>
          <Box width={'380px'} flexShrink={0}>
            <TeamConcernsWidget />
          </Box>
        </HStack>

        <PeerSupportDashboardOverview />
      </VStack>

      <CreatorPrompt />
    </VStack>
  );
};

export const Route = createFileRoute('/_authenticated/_organization/organization/dashboard/peer-support')({
  beforeLoad: async ({ context: { auth } }) => {
    const isPeerSupport = auth?.isPeerSupport;
    if (!isPeerSupport) {
      throw redirect({
        to: '/user/dashboard',
      });
    }
  },
  staticData: { title: 'Peer Support' },
  component: PeerSupportDashboard,
});
